import styled from "styled-components";
import Tabbable from "../tabbable";

export const Content = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1100px;
  margin: 0 auto;

  @media (max-width: 1199px) {
    padding: 0 16px;
  }

  @media (min-width: 1920px) {
    max-width: 1500px;
  }
`;

export const LogoBox = styled.a`
  align-items: center;
  display: flex;
  max-width: 235px;
  transition: all 0.5s ease;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ButtonText = styled.p`
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 14px;
  color: #ffffff;
  margin: 5px 0 0 0;
`;

export const LogoImage = styled.img`
  @media (max-width: 1199px) {
    width: 31px;
    height: 30px;
    margin-left: 25px;
  }
`;

export const MenuBox = styled.nav`
  align-items: center;
  display: flex;
  font-family: "Nunito", sans-serif;
`;

export const MenuList = styled.ul`
  align-items: center;
  display: flex;
  height: 100%;
  margin: 0;
  padding: 0;
  list-style: none;

  @media (max-width: 1199px) {
    flex-direction: column;
    align-items: flex-start;
    padding-top: 24px;
  }
`;

export const MenuItem = styled.li`
  &:not(:last-of-type) {
    margin: 0 16px 0 0;
  }

  @media (max-width: 1199px) {
    &:not(:last-of-type) {
      margin: 0 auto 24px;
    }
  }
`;

export const MenuLink = styled.a`
  color: #ffffff;
  font-size: 0.875rem;
  text-transform: uppercase;

  @media (max-width: 1199px) {
    font-weight: 700;
  }
`;

export const FreeTrialLink = styled.a`
  height: 46px;
  margin: 0 32px;
  padding: 12px 33px;
  color: #fff;
  font-weight: 700;
  font-size: 1rem;
  text-transform: uppercase;
  border: 1px solid #fff;
  border-radius: 50px;
  transition: all 0.5s ease;
  white-space: nowrap;
`;

export const PlansButton = styled.a`
  margin-left: 32px;
  height: 46px;
  padding: 12px 24px;
  background-color: #020052;
  border: 1px solid #ffffff;
  font-weight: 700;
  border-radius: 50px;
  color: #ffffff;
  font-size: 1rem;
  line-height: 22px;
  text-transform: uppercase;
  transition: all 0.5s ease;
  cursor: pointer;
  @media (max-width: 1365px) {
    text-align: center;
    max-width: 130px;
    margin-left: 0;
  }

  &:visited,
  &:hover,
  &:focus {
    color: #ffffff;
  }
`;

export const HeaderElement = styled.header`
  background: #020052;
  max-height: 88px;
  padding: 18px 0;
  top: 0;
  transition: all 0.5s ease;
  width: 100%;
  z-index: 10;

  @media (max-width: 1199px) {
    max-height: 64px;
    padding: 16px 0;
  }

  ${(props) =>
    props.isOpen &&
    `
    max-height: fit-content;
    background: #020052;

    @media (max-width: 1199px) {
      max-height: fit-content;
      padding-bottom: 28px;
    }
  `};
`;

export const HamburguerMenuBox = styled(Tabbable)`
  align-items: center;
  display: flex;
  height: 28px;
  justify-content: center;
  position: relative;
  width: 28px;

  &.tabbable {
    color: #020052;
  }

  @media (min-width: 1200px) {
    display: none;
  }
`;

export const HamburguerMenu = styled.span`
  background: none transparent;
  border: 2px solid #ffffff;
  border-left: 0 solid transparent;
  border-right: 0 solid transparent;
  cursor: pointer;
  display: block;
  height: 16px;
  order: 2;
  position: relative;
  transition: all 0.2s;
  width: 24px;

  &:before {
    background: #ffffff;
    content: "";
    height: 2px;
    left: 0;
    position: absolute;
    top: 5px;
    transition: all 0.2s;
    width: 24px;
  }

  &:after {
    background: #ffffff;
    content: "";
    height: 2px;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 6px;
    transform: rotate(90deg);
    transition: all 0.2s;
    visibility: hidden;
    width: 100%;
  }

  ${(props) =>
    props.isOpen &&
    `
    border: 2px solid #ffffff;
    border-radius: 50%;
    height: 28px;
    top: 0;
    transform: rotate(-135deg);
    width: 28px;

    &:before {
      background: #ffffff;
      left: 6px;
      top: 11px;
      width: 12px;
    }

    &:after {
      background: #ffffff;
      left: 6px;
      opacity: 1;
      top: 11px;
      visibility: visible;
      width: 12px;
    }
  `}

  @media (min-width: 1200px) {
    display: none;
  }
`;

export const LoginText = styled.a`
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  margin-left: 32px;
`;

export const LoginButton = styled.div`
  margin-left: 32px;
  width: 15px;
  height: 16px;
  background: url("/assets/asset-menu-login-desktop.svg") center/cover no-repeat;
  cursor: pointer;

  @media (max-width: 1365px) {
    margin-left: 0;
  }
`;

export const MobileTopWrapper = styled(Content)``;

export const MobileBottomWrapper = styled(MenuBox)`
  flex-direction: column;
  align-items: center;
  width: 100%;
  transition: all 0.2s;
  visibility: hidden;
  opacity: 0;
  z-index: 11;

  ${(props) =>
    props.isOpen &&
    `
      opacity: 1;
      visibility: visible;
    `}
`;

export const MobileMenuItem = styled.div`
  margin: 0 auto 24px;
`;

export const ModalRegisterButton = styled(PlansButton)`
  width: 224px;
  height: 43px;
  /* margin-bottom: 24px; */
  padding: 10px 32px;
`;

export const MobileFreeTrialButton = styled(FreeTrialLink)`
  width: 224px;
  height: 43px;
  padding: 10px 32px;
  text-align: center;
`;
